import { observer } from "mobx-react-lite";
import { useAuthStore } from "../hooks";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import { useTran } from "@/hooks";

export const SessionWarningDialog = observer(() => {
  const { t } = useTran();
  const authStore = useAuthStore();

  return (
    <Dialog
      open={authStore.showSessionWarning}
      onOpenChange={() => {
        authStore.dismissSessionWarning();
      }}
    >
      <DialogContent
        className="sm:max-w-md"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/20">
              <Clock className="h-5 w-5 text-orange-600 dark:text-orange-500" />
            </div>
            <DialogTitle>{t("Session Expiring Soon")}</DialogTitle>
          </div>
        </DialogHeader>

        <DialogDescription className="py-4">
          {t("Your session will expire in 2 minutes. Please save your work.")}
        </DialogDescription>

        <DialogFooter className="pt-2">
          <Button variant="outline" onClick={authStore.dismissSessionWarning}>
            {t("Dismiss")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

SessionWarningDialog.displayName = "SessionWarningDialog";
